// @ts-nocheck
const isNil = (value) => value === undefined || value === null
export const notNil = (value) => !isNil(value)

export const isObject = (value) =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export const pick = (arr, obj) =>
  arr.reduce((acc, it) => (it in obj ? { ...acc, [it]: obj[it] } : acc), {})

export const path = (arr, obj, def = undefined) =>
  arr.reduce(
    (acc, it) =>
      acc !== def && {}.hasOwnProperty.call(acc, it) && acc[it] !== null ? acc[it] : def,
    obj,
  )

export const isEmpty = (val) => val === null || !(Object.keys(val) || val).length

export const nonEmpty = (o = {}, def = undefined) => {
  const res = Object.entries(o)
    .filter(([, val]) => notNil(val))
    .reduce((acc, [key, val]) => ({ ...acc, [key]: val }), {})

  return isEmpty(res) ? def : res
}

/**
 * Map over an objects entries
 *
 * @param {Function} f - Function to apply to tuples of Key/Values
 * @param {Object} obj - The object to map over
 */
export const mapObj = (f = (i) => i, obj) =>
  Object.entries(obj).reduce((acc, [key, val]) => ({ ...acc, [key]: f(val) }), {})

export const compose = (...fns) =>
  fns.reduce(
    (f, g) =>
      (...args) =>
        f(g(...args)),
  )

export const unpick = (arr, obj) =>
  Object.entries(obj).reduce(
    (acc, [key, val]) => (arr.includes(key) ? acc : { ...acc, [key]: val }),
    {},
  )
